module.exports = __webpack_public_path__ + "img/server.8a35db8c.jpg";